import hungryMonkeyGame from "../assets/images/hungry-monkey.png";
import designScoringProject from "../assets/images/design-lint.png";
import customerSurveyAnalytics from "../assets/images/customer-survey-analytics.jpeg";
import DocumentImageDenoising from "../assets/images/document-image-denoising.jpeg";
import DocImageRestoration from "../assets/images/doc-img-restoration.jpeg";
import PatchEncoderDocImg from "../assets/images/patch-encoder-doc-img.png";
import VerzeoCertification from "../assets/images/verzeo-internship-certificate.jpg";
import CCNACert from "../assets/images/CCNA-cert.png";
import portfolioPreview from "../assets/images/netflix-styled-portfolio.png";
import authServicePreview from "../assets/images/sentry-lite-rbac.png";
import toDesktopClone from "../assets/images/to-desktop-clone.png";

export const projects = [
  {
    id: 1,
    title: "Hungry Monkey Game",
    subtitle: "A flexbox learning game with Tailwind CSS",
    description:
      "Interactive Tailwind CSS learning game inspired by Flexbox Froggy, featuring animated characters, levels, hints, and real-time code validation.",
    longDescription:
      "Designed and built a gamified learning experience using Tailwind CSS to teach concepts interactively. The game features animated characters and themed levels that progressively introduce Tailwind utilities. Players type Tailwind classes in a built-in code editor to match a target layout, with instant visual feedback, custom animations, sound effects, and a progress system. Implemented dynamic class evaluation, level-based components, contextual hints, and in-game documentation mapping CSS properties to Tailwind utility classes.",
    technologies: [
      "JavaScript",
      "React",
      "Tailwind CSS",
      "Flexbox",
      "Framer Motion",
      "Vite",
    ],
    categories: ["Frontend"],
    image: hungryMonkeyGame + "?w=800&h=600&fit=crop",
    demoUrl: "https://techwithpranjal.github.io/hungry-monkey-game/",
    githubUrl: "https://github.com/techwithpranjal/hungry-monkey-game",
    type: "highlighted",
    completedDate: "2025-06-01",
  },
  {
    id: 2,
    title: "Sentry Lite",
    subtitle: "OAuth2 + JWT-based authentication and authorization platform",
    description:
      "A centralized authentication and authorization service using OAuth2 and JWT, enabling secure role-based access for 15+ enterprise applications.",
    longDescription:
      "Designed and implemented a production-grade authentication and authorization platform leveraging OAuth 2.0 and JWT tokens. Built Role-Based Access Control (RBAC) to standardize permissions across 15+ internal applications, reducing duplicated security logic and improving compliance. Integrated granular role and privilege assignment, token lifecycle management, service-to-service authentication, and audit logging. Collaborated with cross-functional teams to onboard applications seamlessly and enhance security posture across the ecosystem.",
    technologies: [
      "Angular",
      "TypeScript",
      "Python",
      "FastAPI",
      "SQLite",
      "REST APIs",
      "OAuth2",
      "JWT",
      "Role-Based Access Control (RBAC)",
    ],
    categories: ["Full Stack"],
    image: authServicePreview + "?w=800&h=600&fit=crop",
    demoUrl: "https://techwithpranjal.github.io/sentry-lite-rbac/#/login",
    githubUrl: "https://github.com/techwithpranjal/sentry-lite-rbac",
    summaryUrl: "",
    sampleUrl: "",
    type: "highlighted",
    completedDate: "2025-10-01",
  },
  {
    id: 3,
    title: "Design Lint",
    description:
      "Lightweight browser extension for real-time, in-context evaluation of UI accessibility, readability, and design quality on live webpages.",
    longDescription:
      "Built a JavaScript-based browser extension that analyzes UI elements directly in the DOM to surface accessibility, readability, and design quality insights in real time. The extension integrates with a scoring engine to highlight issues inline, enabling designers and engineers to identify and fix UI gaps without leaving the page. This lightweight version was created as a demo-friendly representation of a larger production system used to evaluate design quality at scale.",
    technologies: [
      "React",
      "JavaScript",
      "Browser Extension APIs",
      "DOM APIs",
      "Accessibility APIs",
      "Axe-core",
      "HTML5",
      "CSS3",
    ],
    categories: ["Frontend"],
    image: designScoringProject + "?w=600&h=600&fit=crop",
    demoUrl:
      "https://github.com/techwithpranjal/design-lint/releases/tag/v1.0.0",
    githubUrl: "https://github.com/techwithpranjal/design-lint",
    summaryUrl: "",
    type: "highlighted",
    completedDate: "2026-01-10",
  },
  {
    id: 4,
    title: "Netflix-Styled Portfolio",
    subtitle: "A modern personal portfolio inspired by Netflix UI",
    description:
      "A sleek, Netflix-inspired portfolio featuring card-based sections, rich animations, and a bold red-black theme.",
    longDescription:
      "Designed and developed a fully responsive developer portfolio styled after Netflix’s signature UI. Built with React, Tailwind CSS, and Framer Motion, the site uses cinematic layouts, dynamic hover interactions, category-based project carousels, and polished section transitions. Includes a custom contact form powered by EmailJS, a timeline-based Experience & Education section, and an optimized two-column About layout. The design emphasizes accessibility, performance, and storytelling through a visually engaging interface inspired by the Netflix dashboard.",
    technologies: [
      "React",
      "JavaScript",
      "Tailwind CSS",
      "Responsive UI Design",
    ],
    categories: ["Frontend"],
    image: portfolioPreview + "?w=800&h=600&fit=crop",
    demoUrl: "https://techwithpranjal.github.io/netflix-styled-portfolio/",
    githubUrl: "https://github.com/techwithpranjal/netflix-styled-portfolio",
    type: "regular",
    completedDate: "2025-01-15",
  },
  {
    id: 5,
    title: "ToDesktop UI Clone",
    subtitle: "A modern desktop-style web UI built with Tailwind CSS",
    description:
      "A sleek ToDesktop-inspired web app clone with smooth animations, floating UI elements, and interactive customizations.",
    longDescription:
      "Built a clean and modern ToDesktop-style interface using Tailwind CSS, focusing on seamless animations, floating card layouts, and interactive toggle controls. The project recreates the look and feel of desktop application customization panels, with a refined design system, smooth hover transitions, responsive layouts, and modular component organization. Ideal for showcasing UI/UX craftsmanship and animation work using utility-first CSS.",
    technologies: ["HTML", "CSS", "Tailwind CSS", "JavaScript", "Animations"],
    categories: ["Frontend"],
    image: toDesktopClone + "?w=800&h=600&fit=crop",
    demoUrl: "https://techwithpranjal.github.io/to-desktop-clone/",
    githubUrl: "https://github.com/techwithpranjal/to-desktop-clone",
    type: "regular",
    completedDate: "2025-02-01",
  },
  {
    id: 6,
    title: "API Gateway Service",
    description:
      "Microservices API gateway with rate limiting, authentication, load balancing, and monitoring capabilities.",
    longDescription:
      "Designed and implemented a robust API gateway service to manage microservices communication. The gateway handles authentication, rate limiting, request routing, load balancing, and provides comprehensive monitoring and logging capabilities. Built with Node.js and Redis for caching, it supports both REST and GraphQL APIs. The service includes circuit breaker patterns for fault tolerance and integrates with monitoring tools like Prometheus and Grafana for observability.",
    technologies: ["Python Flask", "RESTful APIs", "Kubernetes"],
    categories: ["Backend"],
    image:
      "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&h=600&fit=crop",
    demoUrl: null,
    githubUrl: "https://github.com/username/api-gateway",
    type: "regular",
    completedDate: "2024-04-05",
  },
  // {
  //   id: 6,
  //   title: "CSAT Survey Analytics",
  //   description:
  //     "Unified Voice-of-Customer-as-a-Service (VoCaaS) platform for customer satisfaction (CSAT) survey analytics, driving actionable customer insights.",
  //   longDescription:
  //     "Built a unified analytics experience for Voice-of-Customer-as-a-Service (VoCaaS) insights by standardizing UI/UX across CSAT survey applications. Migrated legacy systems to DDS 2.0, integrated 15+ CSAT tools using Flask-based microservices and REST APIs, and delivered an interactive React dashboard for customer sentiment analysis. The platform improved user adoption by 60% and reduced operational effort by 50%, enabling data-driven improvements in customer experience strategy.",
  //   technologies: [
  //     "React",
  //     "Flask",
  //     "Python",
  //     "MySQL",
  //     "REST APIs",
  //     "Microservices Architecture",
  //     "Machine Learning",
  //   ],
  //   categories: ["Full Stack"],
  //   image: customerSurveyAnalytics + "?w=800&h=600&fit=crop",
  //   demoUrl: "",
  //   githubUrl: "",
  //   summaryUrl: "",
  //   type: "regular",
  //   completedDate: "2024-08-15",
  // },
  {
    id: 7,
    title: "Overview of Document Image Denoising and Restoration Techniques",
    description:
      "Presented at the World Research Forum for Engineers and Researchers (2022) and featured in IJEEDC.",
    longDescription:
      "Presented a comprehensive survey of traditional and deep learning-based document image denoising and restoration techniques. The paper highlights comparative analyses, challenges, and potential research directions in document enhancement. Presented at the World Research Forum for Engineers and Researchers (2022) and featured in IJEEDC.",
    technologies: ["Python", "OpenCV", "Pandas"],
    categories: ["Research"],
    image: DocImageRestoration + "?w=800&h=600&fit=crop",
    linkUrl:
      "http://iraj.in/journal/IJEEDC/paper_detail.php?paper_id=18570&name=Overview_of_Document_Image_Denoising_and_Restoration_Techniques",
    type: "publication",
    publication: "IJEEDC",
    year: "2022",
  },
  {
    id: 8,
    title: "Pix2Pix GAN with ResNet for Document Image Denoising",
    description:
      "Presented at the 4th International Conference on Inventive Research in Computing (2022) and published in IEEE.",
    longDescription:
      "Proposed a hybrid GAN-based approach combining Pix2Pix and ResNet architectures for document image denoising. The model achieved significant improvement in restoring degraded text documents by preserving structural consistency and reducing background noise. Presented at the 4th International Conference on Inventive Research in Computing (2022) and published in IEEE Xplore.",
    technologies: [
      "Computer Vision",
      "OCR",
      "Deep Learning",
      "GANs",
      "Python",
      "TensorFlow",
      "Keras",
      "OpenCV",
      "NumPy",
      "Matplotlib",
    ],
    categories: ["Research"],
    image: DocumentImageDenoising + "?w=800&h=600&fit=crop",
    linkUrl: "https://ieeexplore.ieee.org/document/9985695",
    type: "publication",
    publication: "IEEE Xplore",
    year: "2022",
  },
  {
    id: 9,
    title:
      "Patch Based Autoencoder for Document Image Denoising with Smoothening",
    description:
      "Exhibited at ICT for Sustainable Development (2022) and published in Springer.",
    longDescription:
      "Developed a patch-based convolutional autoencoder for denoising and smoothening of scanned document images. The model enhances readability and maintains text sharpness while minimizing artifacts. Exhibited at ICT for Sustainable Development (2022) and published in Springer.",
    technologies: [
      "Autoencoders",
      "Image Processing",
      "Deep Learning",
      "PyTorch",
      "OpenCV",
      "NumPy",
      "Matplotlib",
      "Scikit-image",
    ],
    categories: ["Research"],
    image: PatchEncoderDocImg + "?w=800&h=600&fit=crop",
    linkUrl: "https://link.springer.com/chapter/10.1007/978-981-19-5331-6_62",
    type: "publication",
    publication: "Springer",
    year: "2022",
  },
];

export const skillCategories = {
  "Frontend Development": [
    "HTML5",
    "CSS3",
    "JavaScript (ES6+)",
    "TypeScript",
    "React.js",
    "Redux Toolkit",
    "Tailwind CSS",
    "Material UI",
    "CSS Modules",
    "Responsive Web Design",
  ],
  "Backend Development": [
    "Python",
    "Flask",
    "RESTful APIs",
    "FastAPI",
    "Microservices Architecture",
    "OAuth2",
    "JWT",
    "RBAC",
    "SSO",
    "SAML",
  ],
  Databases: ["PostgreSQL", "MySQL"],
  "DevOps & Cloud": [
    "Podman",
    "Kubernetes",
    "GitLab CI/CD",
    "Pivotal Cloud Foundry",
    "AWS (S3)",
  ],
  "Testing & Quality": [
    "Jest",
    "Vitest",
    "PyTest",
    "Postman (API Testing)",
    "Test-Driven Development (TDD)",
  ],
  "Software Practices": [
    "Git & GitLab",
    "Agile Methodologies",
    "Jira",
    "Pair Programming",
    "CI/CD Pipelines",
    "System Design",
  ],
};

export const experience = [
  {
    id: 1,
    company: "Dell Technologies",
    team: "Behavioral Science",
    position: "Senior Software Engineer",
    location: "Bangalore",
    duration: "Mar 2026 - Present",
    type: "work",
    description:
    "Leading behavioral science initiatives focused on data-driven UX research and experimentation platforms. Building scalable analytics and insight tools in collaboration with researchers and data scientists, while mentoring engineers for technical growth.",
  },
  {
    id: 2,
    company: "Dell Technologies",
    team: "Behavioral Science",
    position: "Software Development Engineer II",
    location: "Bangalore",
    duration: "Feb 2024 - Present",
    type: "work",
    description:
      "Built automated UI scoring tools improving WCAG compliance. Deployed Flask APIs on Kubernetes, increasing uptime by 40%. Led NLP-driven chat analytics cutting manual effort by 50%, and introduced TDD with Jest & Vitest for full CI/CD maturity.",
  },
  {
    id: 3,
    company: "Dell Technologies",
    team: "Customer Sentiment",
    position: "Software Development Engineer I",
    location: "Hyderabad",
    duration: "Aug 2022 - Jan 2024",
    type: "work",
    description:
      "Migrated CSAT apps to DDS 2.0 and built a unified VoCaaS platform with React & Flask, boosting adoption by 60%. Automated issue tracking reduced stakeholder effort by 50%, with secure RBAC via OAuth2 & JWT.",
  },
  {
    id: 4,
    company: "Dell Technologies",
    position: "Software Development Intern",
    location: "Bangalore",
    team: "Employee Lifecycle",
    duration: "Jun 2021 - Jul 2021",
    type: "work",
    description:
      "Built Grafana dashboards for real-time Workday monitoring, reducing troubleshooting time by one-third weekly.",
  },
  {
    id: 5,
    company: "Cummins College of Engineering for Women",
    position: "BTech in Information Technology",
    location: "Pune",
    duration: "Aug 2018 - May 2022",
    type: "education",
    description:
      "Thesis on “Document Image Restoration Techniques using Generative Neural Networks.” Graduated with CGPA 8.8. Relevant coursework: Data Structures, Algorithms, Database Management, Computer Networks, Machine Learning, Web Development.",
  },
];

export const categories = [
  "All",
  "Full Stack",
  "Frontend",
  "Backend",
  "Research",
];

export const awards = [
  {
    title: "Innovation Delight Award",
    description: (
      <>
        Recognized by{" "}
        <span className="text-red-500 font-medium">
          Dell Technologies (2025)
        </span>{" "}
        for delivering an end-to-end design intelligence workflow, a system
        spanning design scoring tools, a browser extension, remediation
        workbench, data dashboards, and large-scale web scraping pipelines.
      </>
    ),
  },
  {
    title: "Game Changer Award",
    description: (
      <>
        Recognized by{" "}
        <span className="text-red-500 font-medium">
          Dell Technologies (2023)
        </span>{" "}
        for innovation and measurable business impact in the
        Voice-of-Customer-as-a-Service platform initiative.
      </>
    ),
  },
  {
    title: "AIR 61 – National Creativity Aptitude Test",
    description: (
      <>
        Achieved{" "}
        <span className="text-red-500 font-medium">
          All-India Rank 61 (2021)
        </span>{" "}
        for excellence in creative reasoning and analytical problem-solving.
      </>
    ),
  },
  {
    title: "1st Runner-Up – CryptHunt 2020",
    description: (
      <>
        Secured{" "}
        <span className="text-red-500 font-medium">
          2nd place among 40 teams
        </span>{" "}
        in a college-level innovation{" "}
        <span className="font-medium">
          treasure hunt and coding competition
        </span>
        , focused on logical reasoning and problem-solving.
      </>
    ),
  },
];

export const links = {
  gitHubLink: "https://github.com/techwithpranjal",
  linkedInLink: "https://www.linkedin.com/in/pranjal-jadhav851/",
  mailLink: "pranjaljadhav851@gmail.com",
};

export const certifications = [
  {
    id: 1,
    title: "Full Stack Web Development",
    description:
      "Completed a project-driven course on frontend and backend web development.",
    skills: ["HTML", "CSS", "JavaScript", "React", "Node.js"],
    year: "2021",
    linkUrl: VerzeoCertification,
  },
  {
    id: 2,
    title: "ReactJS, Routers & Redux",
    description:
      "Comprehensive hands-on course covering React Hooks, Redux Toolkit, and React Router.",
    skills: ["React", "Redux", "Routing", "Hooks", "SPAs"],
    year: "2024",
    courseUrl:
      "https://www.udemy.com/course/react-the-complete-guide-incl-redux",
  },
  {
    id: 3,
    title: "REST APIs with Flask & Python",
    description:
      "Built RESTful APIs with authentication, database models, and deployment best practices.",
    skills: ["Flask", "Python", "REST APIs", "JWT"],
    year: "2023",
    courseUrl: "https://www.udemy.com/course/rest-api-flask-and-python/",
  },
  {
    id: 4,
    title: "Deep Learning",
    description:
      "Mastered neural networks, CNNs, and sequence models with TensorFlow and Keras.",
    skills: ["Deep Learning", "TensorFlow", "Keras", "CNN"],
    year: "2023",
    linkUrl:
      "https://www.coursera.org/account/accomplishments/verify/MQQJQMZD9G5H",
  },
  {
    id: 5,
    title: "Machine Learning",
    description:
      "Learned ML algorithms including regression, SVM, and clustering using Python.",
    skills: ["Machine Learning", "Python", "Scikit-learn"],
    year: "2022",
    linkUrl:
      "https://www.coursera.org/account/accomplishments/verify/6JGSYZAB4PVM",
  },
  {
    id: 6,
    title: "Data Science",
    description:
      "Gained skills in data analysis, visualization, and statistical modeling using Python.",
    skills: ["Data Science", "Python", "Pandas", "Matplotlib"],
    year: "2021",
    linkUrl:
      "https://trainings.internshala.com/verify-certificate/D5C76B35-4325-F8DB-72C7-9ECE6FCB78F1/",
  },
  {
    id: 7,
    title: "Cisco Certified Network Associate Routing and Switching (CCNA)",
    description:
      "Validated knowledge of networking fundamentals, IP connectivity, and security.",
    skills: ["Networking", "Routing", "Switching", "Security"],
    year: "2020",
    linkUrl: CCNACert,
  },
];
